"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceSiteService = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.InvoiceSiteService = typebox_1.Type.Object({
    invoice_number: typebox_1.Type.String(),
    first_name: typebox_1.Type.String(),
    due_date: typebox_1.Type.String(),
    payment_link: typebox_1.Type.String(),
    custom_message: typebox_1.Type.String(),
    allow_check: typebox_1.Type.Boolean(),
    allow_ach: typebox_1.Type.Boolean(),
});
//# sourceMappingURL=invoice-site-service.js.map